export default __webpack_public_path__ + "static/image162-04f6e51782cd0ee7e994a3f155836324.jpg";